module.exports = __webpack_public_path__ + "img/1.6.2-2.deb0e510.jpg";